<template>
  <div class="page-module-wrap">
    <!-- 搜索头部分 start -->
    <div class="search">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <div class="block">
              <button class="button is-info width-1" @click="onShowModal('Add')">添加客服</button>
              <router-link class="button is-success" :to="{ name: 'chatQuickReply'}">常用回复管理</router-link>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- 搜索头部分 end -->
    <!-- 列表部分 start -->
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
              <tr>
                <th>客服</th>
                <th>工作时段</th>
                <th>代运营商家名</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in list">
              <td>{{item.username}}</td>
              <td>{{item.workStartTime}}~{{item.workEndTime}}</td>
              <td>
                <a v-for="businessItem in item.businessUsers" target="_blank" :href="'/admin.php?method=user.show&userId='+businessItem.userId">{{businessItem.username}}、 </a>
              </td>
              <td>
                <button class="button is-success" @click="onShowModal('Edit',index)">编辑</button>
                <button class="button is-danger" @click="onDelete(index)">删除</button>
              </td>
            </tr>
            </tbody>
          </table>
        </article>
      </div>
      <el-dialog :title="modal.title" :visible.sync="modal.visible" :lock-scroll='false'>
        <p class="margin-left margin-top">
          <label class="label inline-block r-top">客服：</label>
          <span class="inline-block">
            <el-select v-model="modal.userId" filterable placeholder="请选择">
              <el-option
                v-for="item in allOptions.csList"
                :key="item.userId"
                :label="item.username"
                :value="item.userId">
              </el-option>
            </el-select>
          </span>
        </p>
        <p class="margin-left margin-top flex">
          <label class="label inline-block r-top">设置工作时间段：</label>
          <el-time-picker
            class='flex-1'
            is-range
            v-model="modal.timeRange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围">
          </el-time-picker>
        </p>
        <p class="margin-left margin-top flex">
          <label class="label inline-block r-top text-align-r">添加代运营商家：</label>
          <el-select v-model="modal.businessUsers" filterable multiple placeholder="请选择" class='flex-1' :reserve-keyword="false">
            <el-option
              v-for="item in allOptions.businessUsers"
              :key="item.userId"
              :label="item.name"
              :value="item.userId">
            </el-option>
          </el-select>
        </p>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modal.visible = false">取 消</el-button>
          <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script type="text/babel">
  import { getTimeByDateStr } from 'UTILS/date'
  export default {
    data(){
      return {
        list:[],
        modal: {
          title: '',
          visible: false,
          type:'',
          bodyStyle:{},
          userId:'',
          username:'',
          startTime:'00:00:00',
          endTime:'00:00:00',
          timeRange: ["00:00:00", "00:00:00"],
          businessUsers:[]
        },
        allOptions:{
          businessUsers:[],
          csList:[]
        }
      }
    },
    mounted(){
      this.getAllOpts()
      this.getList()
    },
    watch:{
      'modal.visible'(){//监听modal.visible变化重置modal中组件
        if(this.modal.visible == false){
          setTimeout(()=>{
            this.modal.type = '';
          },200);
        }
      }
    },
    methods:{
      MODAL_OK_EVENT() {
        let params = {
          adminUserId:this.modal.userId,
          workStartTime:getTimeByDateStr(this.modal.timeRange[0]).split(' ')[1],
          workEndTime:getTimeByDateStr(this.modal.timeRange[1]).split(' ')[1],
          businessUserIds:this.modal.businessUsers
        }

        if(this.modal.type == 'Edit'){
            params.isEdit = 1
        }
        if(!params.adminUserId){
          this.$message('请选择客服!')
          return false;
        }else if(!params.businessUserIds.length){
          this.$message('请选择商家!')
          return false;
        }
        HttpRequest.post('/admin.php?method=agencyoperation.doSaveStaff',params).then(response => {
          if(response.data.result){
            this.modal.visible = false
            this.getList()
          }
        })
      },
      getList(){
        HttpRequest.post('/admin.php?method=agencyoperation.showStaff').then(response => {
          this.list = _.toArray(response.data.list)
          _.each(this.list,(item,index)=>{
            item.businessUsers = _.toArray(item.businessUsers)
          })
        })
      },
      onShowModal(type,index){
        switch (type) {
          case 'Add':
            this.onShowAddModal(type);
            break;
          case 'Edit':
            this.onShowEditModal(type, index);
            break;
        }
      },
      onShowAddModal(type){
        this.modal.type = type;
        this.modal.title = "添加客服";
        this.modal.visible = true;
        this.modal.bodyStyle = {
          'overflow-x': 'initial',
          'overflow-y': 'initial',
          'height':'260px'
        }
        this.modal.businessUsers = []
        this.modal.timeRange = [new Date(2017, 11, 11, 0, 0), new Date(2017, 11, 11, 0, 0)]
        this.modal.username = ''
        this.modal.userId = ''
      },
      onShowEditModal(type,index){
        let list = this.list
        this.modal.type = type;
        this.modal.title = "编辑";
        this.modal.bodyStyle = {
          'overflow-x': 'initial',
          'overflow-y': 'initial',
          'height':'260px'
        };
        this.modal.startTime = list[index].workStartTime
        this.modal.endTime = list[index].workEndTime
        this.modal.businessUsers = list[index].businessUsers.map((item) => { return item.userId })
        this.modal.visible = true;
        this.modal.username = list[index].username
        this.modal.userId = list[index].userId
        this.modal.timeRange = [new Date("2017-11-11 " + list[index].workStartTime), new Date("2017-11-11 " + list[index].workEndTime)]
      },
      getAllOpts(){
        //第三方穿衣商家
        HttpRequest.post('/admin.php?method=Thirdpartybusinessuser.getSimpleList').then(response => {
          this.allOptions.businessUsers = _.toArray(response.data)
          this.allOptions.businessUsers.unshift({
            userId: -1,
            name: '全部'
          })
        })
        //客服列表
        HttpRequest.post('/admin.php?method=agencyoperation.getAdminInfo').then(response => {
          this.allOptions.csList = _.toArray(response.data)
          this.allOptions.csList.unshift({
            userId: -1,
            username: '全部'
          })
        })
      },
      updateBusinessModalSelect(value){
        if(!value) return false;
        let params = {
          username:value.name,
          userId:value.userId
        }
        this.modal.businessUsers.push(params)
      },
      updateCSModalSelect(value){
        this.modal.userId = value.userId
        this.modal.username = value.username
      },
      /**
       * 弹窗删除商家
       */
      onDeleteBusiness(index){
        this.modal.businessUsers.splice(index,1)
      },
      /**
       * 删除客服
       * @param index
       */
      onDelete(index){
        if(!confirm("确认删除？"))return false;
        let params = {
          adminId:this.list[index].userId
        }
        HttpRequest.post('/admin.php?method=agencyoperation.doRemoveStaff',params).then(response => {
          if(response.data.result){
            this.$message('删除成功!')
            this.getList()
          }
        })
      },
    }
  }
</script>
<style rel="stylesheet/less" lang="less">
  .flex {
    display: flex;
  }
  .flex-1 {
    flex: 1
  }
  .page-module-wrap {
    th {
      text-align: center;
      padding: 4px 5px;
    }
    td {
      text-align: center;
      padding: 4px 5px;
      span {
        word-break: break-all;
      }
    }
    p {
      word-break: break-all;
    }
    .clearfix:after {
      content: ".";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    .clearfix {
      _overflow: hidden;
    }
    .fleft {
      float: left;
    }
    .fright {
      float: right;
    }
    .red {
      color: red;
    }
    .green {
      color: green;
    }
    .margin-top {
      margin-top: 10px;
    }
    .margin-bottom {
      margin-bottom: 10px;
    }
    .margin-left {
      margin-left: 40px;
    }
    .width-2 {
      width: 150px;
    }
    .width-3 {
      width: 200px;
      input {
        width: 180px;
      }
    }
    .width-50 {
      width: 50px;
    }
    .inline-block {
      display: inline-block;
    }
    .vertical-middle {
      vertical-align: middle;
    }

    .control {
      display: inline-block;
      margin-right: 20px;
    }
    .margin-left1 {
      margin-left: 20px;
    }
    .r-top {
      position: relative;
      top: 5px;
    }
    .danger {
      background-color: #ed6c63;
      border-color: transparent;
      color: white;
    }
    .list-wrap {
      padding-bottom: 40px;
      .order-item {
        margin-bottom: 30px;
        .img-goods {
          width: 90%;
        }
      }
      .goods-img {
        min-width: 70px;
      }
      .goods-name {
        border: none;
        resize: none;
        height: 80px;
      }
      .goods-name-overflow {
        border: 1px solid red;
      }
    }
    .red {
      color: red;
    }
    .margin-plan {
      margin-top: 10px;
      margin-left: 100px;
    }
    .modal-tip {
      color: #ccc;
      position: relative;
      top: 5px;
    }
    .business-block {
      float: left;
      margin-left: 5px;
      height: 32px;
      line-height: 32px;
      padding: 0 5px;
      border: 1px solid #42AFE3;
      color: #42AFE3;
      position:relative;
      .delete-icon {
        display: none;
        position: absolute;
        top:1px;
        right: 1px;
        color: #E61414;
        font-size: 10px;
        cursor: pointer;
      }
      &:hover {
        .delete-icon {
          display: inline-block;
        }
      }
    }
  }

</style>
